import { UserListIcon } from '@phosphor-icons/react'
import type { ReactElement } from 'react'
import { Tooltip } from 'app/components/Tooltip'
import { PERSONAL_LIST_NOTE } from 'lib/listVisibility'

/** The person icon beside a personal list's name, drawn the way the sidebar draws its live-list marker. */
export function PersonalListMarker({ personal }: { personal: boolean }): ReactElement | null {
  if (!personal) return null
  return (
    <Tooltip message={PERSONAL_LIST_NOTE} className="flex shrink-0">
      <UserListIcon size={12} weight="bold" className="text-subtle" aria-label={PERSONAL_LIST_NOTE} />
    </Tooltip>
  )
}
